"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyGatewayApi = exports.setGatewayApiOptions = void 0;

var _react = require("@reduxjs/toolkit/dist/query/react");

var _path = require("../constants/path.constants");

var _utils = require("../utils");

var _createFetchBaseQuery = (0, _utils.createFetchBaseQueryWithToken)(),
    setGatewayApiOptions = _createFetchBaseQuery.setApiOptions,
    baseQuery = _createFetchBaseQuery.baseQuery;

exports.setGatewayApiOptions = setGatewayApiOptions;
var gatewayApiReducerPath = "".concat(_path.API_BASE_REDUCER_PATH, "gatewayApi");
var emptyGatewayApi = (0, _react.createApi)({
  reducerPath: gatewayApiReducerPath,
  baseQuery: (0, _utils.fetchBaseQueryWithReAuthMutex)(baseQuery()),
  tagTypes: [],
  endpoints: function endpoints() {
    return {};
  }
});
exports.emptyGatewayApi = emptyGatewayApi;